// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1iCeM","notes":"Notes_notes__2Ramp","note":"Notes_note__1M89M","markdown":"Notes_markdown__3l9vE"};